module.exports = __webpack_public_path__ + "static/media/leave4.0f970b89.svg";